<script>
  import { userStore, clientStore, getClient } from "../services/session";
  import { _ } from "../services/i18n";
  import { getImage, ImageTypes } from "../services/vendors";
  import { getImageUrl } from "../services/images";

  import { link as linkFun } from "svelte-spa-router";

  export let links = null
  let klass = ''
  export {klass as class}
  export let style = ''

  let name = $userStore.getClientName()
  
  let headerLogo = null;
  const updateHeaderLogo = async () => {
    if (!getClient()) {
      return;
    }
    headerLogo = await getImage(getClient(), ImageTypes.APP_LOGO);
    if (headerLogo) {
      headerLogo = getImageUrl({ id: headerLogo.imageId });
    }
    else {
      headerLogo = "/icons/default_logo_1.png";
    }
  }

  clientStore.subscribe(async _client => {
    name = $userStore.getClientName();
    await updateHeaderLogo();
  })

  userStore.subscribe(user => {
    name = user.getClientName()
  })

</script>

<header class="home-header {klass}" class:two-columns={!links} {style}>
  <a id="logo-sim3d" href="/">
    {#if headerLogo}
      <img alt="sim3d-logo" src={headerLogo} />
    {/if}
  </a>
  <span  class="user-name"id="user-name-mobile">
    {#if name}
      {$_("Hola")} <strong title={name.length > 25 ? name : ""}>{name}</strong>
    {/if}
  </span>
  {#if links}
    <nav class="home-nav">
      <ul>
        {#each links as link}
          <li class:active-link={link.active}>
            <a href={link.url} use:linkFun>{$_(link.name)}</a>
          </li>
        {/each}
      </ul>
    </nav>
  {/if}
  <span class="user-name" id="user-name-pc">
    {#if name}
      {$_("Hola")} <strong title={name.length > 25 ? name : ""}>{name}</strong>
    {/if}
  </span>
 
</header>

<style>
  nav.home-nav {
    margin: 0 auto;
  }

  .home-nav > ul {
    display: flex;
    width: 35rem;
    justify-content: space-around;
    text-transform: uppercase;
    font-size: 24px;
    letter-spacing: 2px;
    border-bottom: 1.5px solid var(--theme-color-4);
    padding: 0;
    margin-bottom: 0;
  }

  .home-nav > ul > li {
    line-height: 20px;
  }

  .home-nav > ul > li.active-link a {
    border-bottom: 1.5px solid var(--theme-color-4);
  }

  .home-nav a {
    display: block;
    padding: 15px 25px;
    border-bottom: 1.5px solid transparent;
    color: var(--theme-color-4);
  }
  .home-nav a:hover {
    text-decoration: none;
  }

  /* HEADER */
  header.home-header {
    display: grid;
    grid-template-columns: 15fr 70fr 15fr;
    width: 100%;
    align-items: flex-start;
    margin: 20px 0 24px;
  }

  .two-columns {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  #logo-sim3d > img {
    height: 70px;
    margin: 0px 0px 0px 21px;
  }

  .user-name {
    color: var(--theme-color-4);
    z-index: 20;
    position: relative;
    text-transform: uppercase;
    font-size: 18px;
    letter-spacing: 1.7px;
    font-weight: 400;
    display: flex;
    justify-content: end;
    gap: 5px;
    flex-direction: row;
    justify-content: flex-end;
  }

  .user-name strong {
    color: var(--theme-color-1);
    font-weight: 400;
    max-width: 11vw;
    margin-right: 10px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #user-name-mobile {
    display: none;
  }


  /* !HEADER */

  @media (max-width: 1450px) {
    .user-name {
      font-size: 12px;
    }
    #logo-sim3d > img {
    height: 55px;
   }
    
  }

  @media (max-width: 768px) {
    header.home-header {
      flex-direction: column;
      justify-content: center;
      width: 100%;
      align-items: center;
      display: flex;
      margin: 20px 0 20px;
    }

    .user-name {
      margin-top: 10px;
    }

    .user-name strong {
    max-width: 30vh;
    }

    #logo-sim3d > img {
      margin: 0 auto;
      height: 70px;
    }

    .home-nav > ul {
      width: 20rem;
    }
    #user-name-mobile {
      display: flex;
    }

    #user-name-pc {
    display: none;
    }
  
  }
</style>
